import React, { useEffect, useState } from 'react';

const TableOfContents = ({ content }) => {
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    // Extract H2 and H3 from markdown
    const regex = /^(##|###) (.*$)/gim;
    const matches = Array.from(content.matchAll(regex));
    
    const extractedHeadings = matches.map((match, index) => ({
      id: `heading-${index}`,
      level: match[1].length,
      text: match[2].trim(),
    }));

    setHeadings(extractedHeadings);
  }, [content]);

  if (headings.length === 0) return null;

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200 mb-8 sticky top-28">
      <h3 className="text-lg font-bold text-finance-blue mb-4">Inhaltsverzeichnis</h3>
      <nav className="max-h-[60vh] overflow-y-auto toc-scroll pr-2">
        <ul className="space-y-2">
          {headings.map((heading) => (
            <li 
              key={heading.id} 
              className={`${heading.level === 3 ? 'ml-4' : ''} text-sm`}
            >
              <a 
                href={`#${heading.text.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                className="text-slate-600 hover:text-finance-green transition-colors block py-1"
                onClick={(e) => {
                  e.preventDefault();
                  // In a real app with proper markdown parsing IDs, we'd scroll to the ID.
                  // For this simple demo, we just highlight the interaction.
                  alert(`Scroll zu: ${heading.text}`);
                }}
              >
                {heading.text}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default TableOfContents;